import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { api, toEmbedUrl } from "@/lib/api";
import { setDocumentSeo } from "@/lib/seo";
import { ShareButton } from "@/components/ShareButton";

export default function BlogPost() {
  const { slug } = useParams();
  const [post, setPost] = useState(null);
  useEffect(() => { api.get(`/blog/${slug}`).then((r) => { setPost(r.data); setDocumentSeo(r.data.title, (r.data.excerpt || r.data.subtitle || "").slice(0, 160), r.data.image); }).catch(() => setPost(false)); }, [slug]);

  if (post === false) return <div className="py-32 text-center text-[#8A8175]">Post not found. <Link to="/blog" className="text-[#8E9A86] underline">Back to journal</Link></div>;
  if (!post) return <div className="py-32 text-center text-[#8A8175]">Loading…</div>;

  return (
    <article className="max-w-3xl mx-auto px-5 sm:px-8 py-16">
      <Link to="/blog" className="text-sm text-[#8A8175] hover:text-[#8E9A86]">← Back to journal</Link>
      <h1 className="font-heading text-4xl sm:text-5xl text-[#3A3632] mt-5 leading-tight">{post.title}</h1>
      {post.image && <div className="gh-frame overflow-hidden mt-8 gh-fade-up"><img src={post.image} alt={post.title} className="w-full h-[400px] object-cover" /></div>}
      {toEmbedUrl(post.video_url) && (
        <div className="gh-frame overflow-hidden mt-8" data-testid="blogpost-video">
          <div className="aspect-video bg-[#1A1A1A]">
            <iframe src={toEmbedUrl(post.video_url)} title={post.title} className="w-full h-full"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowFullScreen />
          </div>
        </div>
      )}
      <div className="mt-10 text-lg text-[#6B655F] leading-relaxed space-y-6">
        {post.body.split("\n\n").map((para, i) => <p key={`${slug}-para-${i}`}>{para}</p>)}
      </div>
      <div className="mt-10 flex flex-col items-center gap-2 border-t border-[#E5DFD5] pt-8">
        <span className="gh-overline text-[10px]">Share this story</span>
        <ShareButton title={`${post.title} · Hope & Favor`} text={post.excerpt || post.subtitle || post.title} />
      </div>
      <div className="mt-12 bg-[#F2EFEB] rounded-2xl p-8 text-center">
        <p className="font-hand text-3xl text-[#C4A4A4]">Send a little hope today.</p>
        <Link to="/shop" data-testid="blogpost-shop-btn" className="inline-block mt-5 bg-[#8E9A86] text-white rounded-full px-8 py-3.5 font-medium hover:bg-[#7A8772] transition-colors">Browse the boxes</Link>
      </div>
    </article>
  );
}
